require("core-js/modules/es6.function.bind");

module.exports = exports = window.fetch; // Needed for TypeScript and Webpack.

exports["default"] = window.fetch.bind(window);
exports.Headers = window.Headers;
exports.Request = window.Request;
exports.Response = window.Response;